import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const formService = {
    getAllForms, 
    updateFormStatus,
    getForm,
    updateForm,
    createForm,
  };

const MODULE = {
    FORM: 'rnd-forms',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Form') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllForms(filter) {
   
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        name: filter.name,
        is_active: filter.isActive
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return apiHelper(API_URL).get(`/${MODULE.FORM}`, requestOptions)
}


export function updateFormStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.FORM}/${data.id}`, requestOptions)
}

export async function getForm(id) {
  return await apiHelper(API_URL).get(`/${MODULE.FORM}/${id}`)
}

export function updateForm(data) {
  const requestOptions = {
    name: data.name,
    is_active: data.isActive,
  }

  return apiHelper(API_URL).put(`/${MODULE.FORM}/${data.id}`, requestOptions)
}

export function createForm(data) {
  const requestOptions = {
    name: data.name,
  }
  return apiHelper(API_URL).post(`/${MODULE.FORM}`, requestOptions)
}